import { useLiveQuery, useStore } from "@hq/client-react";
import { toast, type ViewMode } from "@z/ui";

/** Remember the chosen presentation for each view across panes and app restarts. */
export function useTaskViewMode(viewId: string): [ViewMode, (mode: ViewMode) => void] {
  const store = useStore();
  const key = `tasks.presentation.${viewId}`;
  const { data } = useLiveQuery(["kv"], (s) => s.kv.get<ViewMode>(key), [key]);
  return [
    data === "board" ? "board" : "list",
    (mode) => {
      void store.kv
        .set(key, mode)
        .catch(() => toast({ title: "Could not save view preference", variant: "danger" }));
    },
  ];
}
